// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

	// if item should be reloaded every time it's accessed, remove it from cache
	if ( typeof moduleId === "string" ){
	var paths = ["client/js/partials/","client\\js\\partials\\"];
	for( var i=0; i<paths.length; i++){
	var path = paths[i];
	if( moduleId.indexOf( path ) !== -1 ){
	delete __webpack_module_cache__[moduleId];
	break;
	}
	}
	}
	// Check if module is in cache
	var cachedModule = __webpack_module_cache__[moduleId];
	if (cachedModule !== undefined) {
		return cachedModule.exports;
	}
	// Create a new module (and put it into the cache)
	var module = __webpack_module_cache__[moduleId] = {
		// no module.id needed
		// no module.loaded needed
		exports: {}
	};

	// Execute the module function
	__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	// Return the exports of the module
	return module.exports;
}

// expose the modules object (__webpack_modules__)
__webpack_require__.m = __webpack_modules__;

